<script setup lang="ts">
const { vacancy } = defineProps<{ vacancy: Vacancy }>()

// const organizationSlug = vacancy.organizationName.replace(' ', '-')
// const vacancySlug = vacancy.title.replace(' ', '-')
// const deedmobUrl = `https://www.geldersehanden.nl/o/${organizationSlug}/activiteitenkalender/${vacancySlug}/${vacancy.deedmobImportId}`

const isOpen = ref(false)
function toggleMetaInfo() {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <BaseCard class="mt-4 p-4" color="muted">
    <NuxtLink
      class="text-muted-500 flex cursor-pointer items-center gap-2 text-sm"
      to="#"
      @click.prevent="toggleMetaInfo"
    >
      <Icon :name="`heroicons:chevron-${isOpen ? 'down' : 'right'}`" />

      <span>Aangemaakt op: {{ $d(vacancy.createdAt, 'long') }}</span>
    </NuxtLink>

    <div v-if="isOpen" class="mt-4">
      <div class="text-muted-500 space-y-1 text-sm">
        <div class="flex">
          <span class="w-32">Laatste update op:</span>
          <span>{{ $d(vacancy.updatedAt, 'long') }}</span>
        </div>
        <div class="flex">
          <span class="w-32">Gepubliceerd op:</span>
          <span>{{ vacancy.publishedAt ? $d(vacancy.publishedAt, 'long') : '-' }}</span>
        </div>
        <div class="flex">
          <span class="w-32">Zichtbaar tot:</span>
          <span>{{ vacancy.visibilityEndDate ? $d(vacancy.visibilityEndDate, 'long') : '-' }}</span>
        </div>
      </div>
    </div>
  </BaseCard>
</template>
